var codeInputThemeNative = {
  container: {
    borderColor: 'border.inactive',
    outerBorderRadius: 4
  },
  characterInput: {
    background: 'background',
    borderWidth: 2,
    width: 48,
    height: 56,
    fontSize: 'xl',
    fontWeight: 'medium'
  }
};

export { codeInputThemeNative };
